"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
exports.shipmentDetailsConvertTime = function (data) {
    if (data) {
        if (data.expectedArrivalDate) {
            data.actualETA = data.expectedArrivalDate;
            data.expectedArrivalTime = moment_1.default(data.expectedArrivalDate.expectedTimeOpen).format('HH:mm') + " - " + moment_1.default(data.expectedArrivalDate.expectedTimeClose).format('HH:mm');
            data.expectedArrivalDate = moment_1.default(data.expectedArrivalDate.expectedDate).format('Do MMMM');
        }
        for (var _i = 0, _a = data.shipmentHistory; _i < _a.length; _i++) {
            var history_1 = _a[_i];
            if (history_1.date) {
                history_1.date = moment_1.default(history_1.date).format('DD-MM-YYYY');
            }
            if (history_1.shipmentLogs) {
                for (var _b = 0, _c = history_1.shipmentLogs; _b < _c.length; _b++) {
                    var shipmentLog = _c[_b];
                    shipmentLog.time = moment_1.default(shipmentLog.time).format('HH:mm');
                }
            }
        }
    }
    return data;
};
